import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { SymptomsSection } from './components/SymptomsSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductPresentation } from './components/ProductPresentation';
import { OfferStack } from './components/OfferStack';
import { WhySoCheap } from './components/WhySoCheap';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-primary-bg font-sans text-text-primary selection:bg-accent/30 pb-20 sm:pb-0" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <IdentificationSection data-id="element-4" />
        <SymptomsSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <OfferStack data-id="element-8" />
        <WhySoCheap data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>
      <StickyCTA data-id="element-14" />
    </div>;
}